import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css/navigation';
import "swiper/css";
import "./Group_of_companies.css"
import Common_heading from '../../common_component/common_heading/Common_heading';

function Group_of_companies() {
    return (
        <>
            <section className='Group_of_companies'>
                <Common_heading title="GROUP OF COMPANIES" subTitle="Connecting Businesses Across Sectors And Borders" />

                <div className='swiper_holder'>
                    <div className="container">
                        <Swiper className="companies_mySwiper"
                            slidesPerView={5.5}
                            spaceBetween={15}
                            navigation={true}
                            loop
                            modules={[Navigation,Autoplay]}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            breakpoints={{
                                // when window width is >= 320px
                                320: {
                                    slidesPerView: 2.3,
                                    spaceBetween: 10,
                                },
                                // when window width is >= 480px
                                480: {
                                    slidesPerView: 3,
                                    spaceBetween: 20,
                                },
                                // when window width is >= 768px
                                768: {
                                    slidesPerView: 3.5,
                                    spaceBetween: 30,
                                },
                                // when window width is >= 1024px
                                1024: {
                                    slidesPerView: 4.5,
                                    spaceBetween: 30,
                                },

                                // when window width is >= 1040px
                                1400: {
                                    slidesPerView: 5.5,
                                    spaceBetween: 50,
                                },
                            }}>
                            <SwiperSlide>
                                <div className='img_holder'>
                                    <img className="companie_img"
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/home/group_of_companies/img_1.png"
                                        }
                                        alt="companie img" />
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='img_holder'>
                                    <img className="companie_img"
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/home/group_of_companies/img_2.png"
                                        }
                                        alt="companie img" />
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='img_holder'>
                                    <img className="companie_img"
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/home/group_of_companies/img_3.png"
                                        }
                                        alt="companie img" />
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='img_holder'>
                                    <img className="companie_img"
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/home/group_of_companies/img_4.png"
                                        }
                                        alt="companie img" />
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='img_holder'>
                                    <img className="companie_img"
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/home/group_of_companies/img_5.png"
                                        }
                                        alt="companie img" />
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='img_holder'>
                                    <img className="companie_img"
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/home/group_of_companies/img_6.png"
                                        }
                                        alt="companie img" />
                                </div>
                            </SwiperSlide>

                        </Swiper>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Group_of_companies